import { addWalletBalance, deductWalletBalance, getWalletInfo , getAccountBillingDetails} from "../types/account_wallet_types";

export const getWalletInfoRequest = (req, cb) => ({
  type: getWalletInfo.GET_WALLET_INFO_REQUEST,
  payload: req,
  cb,
});

export const getWalletInfoSuccess = (res) => ({
  type: getWalletInfo.GET_WALLET_INFO_SUCCESS,
  payload: res,
});

export const getWalletInfoError = (err) => ({
  type: getWalletInfo.GET_WALLET_INFO_ERROR,
  payload: err,
});

export const addWalletBalanceRequest = (payload, cb) => ({
  type: addWalletBalance.ADD_WALLET_BALANCE_REQUEST,
  payload,
  cb,
});
export const addWalletBalanceSuccess = (payload) => ({
  type: addWalletBalance.ADD_WALLET_BALANCE_SUCCESS,
  payload,
});
export const addWalletBalanceError = (payload) => ({
  type: addWalletBalance.ADD_WALLET_BALANCE_ERROR,
  payload,
});

export const deductWalletBalanceRequest = (payload, cb) => ({
  type: deductWalletBalance.DEDUCT_WALLET_BALANCE_REQUEST,
  payload,
  cb,
});
export const deductWalletBalanceSuccess = (payload) => ({
  type: deductWalletBalance.DEDUCT_WALLET_BALANCE_SUCCESS,
  payload,
});
export const deductWalletBalanceError = (payload) => ({
  type: deductWalletBalance.DEDUCT_WALLET_BALANCE_ERROR,
  payload,
});

export const getAccountBillingDetailsRequest = (payload) => ({
  type: getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_REQUEST,
  payload
});

export const getAccountBillingDetailsSuccess = (res) => ({
  type: getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_SUCCESS,
  payload: res,
});

export const getAccountBillingDetailsError = (err) => ({
  type: getAccountBillingDetails.GET_ACCOUNT_BILLING_DETAILS_ERROR,
  payload: err,
});
